import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-343afdf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "what-we-value" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "what-we-value__header" }
const _hoisted_4 = { class: "subtitle subtitle--left text-primary" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "lead" }
const _hoisted_7 = { class: "what-we-value__image" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "what-we-value__image" }
const _hoisted_10 = { class: "what-we-value__header" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "container text-center" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Explore more of Engenious life ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_thumb = _resolveComponent("thumb")!
  const _component_icon_arrow_link = _resolveComponent("icon-arrow-link")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.page?.overSubtitle), 1),
        _createElementVNode("h2", {
          class: "what-we-value__title highlighted highlighted--primary",
          innerHTML: _ctx.titlePipe(_ctx.page?.title)
        }, null, 8, _hoisted_5),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.page?.lead), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_thumb, {
          file: _ctx.page?.additionalThumb1
        }, null, 8, ["file"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_thumb, {
          file: _ctx.page?.additionalThumb2
        }, null, 8, ["file"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h2", {
          class: "what-we-value__title highlighted highlighted--primary",
          innerHTML: _ctx.titlePipe(_ctx.page?.additionalThumb2?.title)
        }, null, 8, _hoisted_11)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_router_link, {
          to: "/our-team",
          class: "btn btn--link"
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _createVNode(_component_icon_arrow_link)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}